<template>
    <div class="cartaoMobile" v-if="mostrar">
        <div class="header">
            <p class="fonte-secundaria negrito corTextoSecundaria tituloHeader">Papéis da aplicação</p>
            <unicom-icone class="icone-fechar" nome="x" :tamanho="18" @click="fecharModal" />
        </div>

        <div class="body">
            <unicom-linha v-for="(papel, index) in papeis" :key="index" class="papeis">
                <unicom-coluna md="1">
                    <unicom-checkbox
                        class="checkbox"
                        v-model="checkBoxSelecionado"
                        :value="papel.id"
                        :inativo="isCheckboxDisabled(papel)"
                    />
                </unicom-coluna>
                <unicom-coluna md="10">
                    <div class="texto">{{ papel.nome }}</div>
                </unicom-coluna>
            </unicom-linha>
        </div>

        <div class="footer">
            <p class="fonte-secundaria corTextoSecundaria">
                papéis do usuário {{ quantidadePapeisSelecionados }}/{{ quantidadePapeis }}
            </p>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: Boolean,
        papeis: {
            type: Array,
            default: () => []
        },
        papeisSelecionados: {
            type: Array,
            default: () => []
        },
        indexColuna: {
            type: Number,
            default: -1
        },
    },
    data() {
        return {
            mostrar: this.value,
            sessaoUsuario: this.getSession(),
            checkBoxSelecionado: this.papeisSelecionados.map(el => el.id),
            papeisRestritos: {
                COREN: ['perfil_auditor_medico', 'camara_medico'],
                CRM: ['perfil_auditor_enfermagem', 'camara_enfermagem'],
                OUTROS: ['perfil_auditor_enfermagem', 'camara_enfermagem', 'perfil_auditor_medico', 'camara_medico']
            },
            tipoConselhoProfissionalUsuario: this.$store.getters.tipoConselhoProfissionalUsuario
        };
    },
    methods: {
        isCheckboxDisabled(papel) {
            const papeisRestritos = this.papeisRestritos[this.tipoConselhoProfissionalUsuario] || this.papeisRestritos['OUTROS'];
            if (papeisRestritos.includes(papel.nome)) {
                return !papel.existeParaUsuario;
            }
            return false;
        },
        fecharModal() {
            this.$emit("fechar");
        }
    },
    watch: {
        value(newVal) {
            this.mostrar = newVal;
        },
        checkBoxSelecionado() {
            this.$emit("papeis-selecionados", {
                index: this.indexColuna,
                papeis: this.papeis.filter(item => this.checkBoxSelecionado.includes(item.id))
            });
        }
    },
    computed: {
        quantidadePapeis() {
            return this.papeis.length;
        },
        quantidadePapeisSelecionados() {
            return this.checkBoxSelecionado.length;
        }
    }
};
</script>

<style lang="scss" scoped>
.cartaoMobile {
    position: absolute;
    z-index: 9999;
    height: 250px;
    width: 250px;
    box-sizing: border-box;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.22);
    border-radius: 10px;
    border: none;
    background-color: #fff;
    .header {
        position: relative;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 15px 18px 8px 18px;
        border-bottom: 1px solid #f1f2f1;
        .icone-fechar {
            color: #9e9e9e;
            cursor: pointer;
            &:hover {
                opacity: 0.9;
                color: grey;
            }
            &:active {
                opacity: 0.5;
            }
        }
    }
    .body {
        height: 160px;
        overflow-y: scroll;
        padding: 15px 0;
        .papeis {
            display: flex;
            align-items: center;
            padding: 10px;
            border-bottom: 1px solid #f1f2f1;
            .texto {
                padding-left: 10px;
            }
        }
    }
    .footer {
        position: absolute;
        bottom: 6px;
        right: 6px;
        p {
            text-align: end;
        }
    }
}
</style>
